import { useContext } from "react";
import { ProfileContext } from "@/features/profiles/ProfileProvider";

export function useProfile() {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error("useProfile must be used inside ProfileProvider");
  return ctx;
}
